// =============================================================================
//  Copyright   : 2018 semantics GmbH
//  Date        : $Date: 2020-03-06 01:26:01 +0100 (Fri, 06 Mar 2020) $
//  Author      : Dirk Rothe
//  Worker      : $Author: d.rothe $
//  Revision    : $Rev: 108221 $
//  Purpose     : call wiki apis
// =============================================================================
// ---Third-party imports
import {put, takeEvery, select} from 'redux-saga/effects'

// ---Framework imports
import log from 'uix/logging'
import {dismissNotification} from './actions'
import {delay} from 'uix/sagas'

// ---Globals
function* _showNotification({payload}) {
  let {dismissAfter, id} = payload
  if (dismissAfter) {
    yield delay(dismissAfter)
    let isVisible = select(root => root.data.notify.some(e => e.id === id))
    if (isVisible) {
      yield put(dismissNotification(id))
    }
  }
}

export const sagas = {
  showNotification: takeEvery('NOTIFICATION_SHOW', _showNotification),
  warnNotification: takeEvery('NOTIFICATION_WARN', _showNotification),
  succNotification: takeEvery('NOTIFICATION_SUCCESS', _showNotification),
  errorNotification: takeEvery('NOTIFICATION_ERROR', _showNotification),
}
